import styled from 'styled-components';

export const List = styled.ul`
  list-style-type: none;
  display: flex;
  flex-flow: column;
  padding: 0;
  position: relative;
  z-index: 1;

  @media (min-width: 992px) {
    flex-flow: row;
    margin-bottom: 0.4rem;
  }
`;

export const Item = styled.li`
  margin-bottom: 0.6rem;
  align-items: stretch;
  display: flex;

  @media (min-width: 992px) {
    flex-basis: 33%;
    margin-bottom: 0;

    &:not(:last-child) {
      margin-right: 0.62rem;
    }
  }
`;
